import React from "react";
import TextField from "../Partial/TextField";
import Button from "../Partial/Button";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  createUserApiCall,
  loginApiCall,
} from "../../store/actions/projectAction";
import { Link } from "react-router-dom";
import { ROTUES } from "../../utils/global";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { setLoading } from "../../store/reducer/projectSlice";
import { toast } from "react-toastify";

function AdminLogin() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const doLogin = async (token) => {
    await window.localStorage.setItem("token", token);

    await dispatch(
      loginApiCall({
        role: "admin",
        token,
      })
    );
  };

  // const handleLogin = async (data) => {
  //   const auth = getAuth();
  //   console.log(data);
  //   dispatch(
  //     setLoading({
  //       code: "firebase_admin_login",
  //       loading: true,
  //     })
  //   );
  //   createUserWithEmailAndPassword(auth, data?.email, data?.password)
  //     .then(async (userCredential) => {
  //       dispatch(
  //         setLoading({
  //           code: "firebase_admin_login",
  //           loading: false,
  //         })
  //       );
  //       // Signed in
  //       const user = userCredential.user;
  //       const token = await user.getIdToken();
  //       await window.localStorage.setItem("token", token);
  //       console.log(user, "user");

  //       dispatch(
  //         createUserApiCall({
  //           role: "admin",
  //           email: data?.email,
  //           token,
  //         })
  //       ).then((result) => {
  //         if (result?.payload?.success) {
  //           // window.location.href = ROTUES.login;
  //           window.location.href = "/admin";
  //         }
  //       });

  //       // ...
  //     })
  //     .catch((error) => {
  //       console.log(error);

  //       const errorCode = error.code;
  //       const errorMessage = error.message;

  //       if (errorCode == "auth/email-already-in-use") {
  //         signInWithEmailAndPassword(auth, data?.email, data?.password)
  //           .then(async (userCredential) => {
  //             // Signed in
  //             dispatch(
  //               setLoading({
  //                 code: "firebase_admin_login",
  //                 loading: false,
  //               })
  //             );
  //             const user = userCredential.user;
  //             const token = await user.getIdToken();
  //             doLogin(token);
  //             console.log(user, "user");
  //           })
  //           .catch((error) => {
  //             const errorCode = error.code;
  //             const errorMessage = error.message;

  //             if (errorCode == "auth/invalid-credential") {
  //               toast.error("Invalid credential");
  //             }

  //             dispatch(
  //               setLoading({
  //                 code: "firebase_admin_login",
  //                 loading: false,
  //               })
  //             );
  //           });
  //       }
  //     });
  // };

  const handleLogin = async (data) => {
    const auth = getAuth();
    dispatch(
      setLoading({
        code: "firebase_admin_login",
        loading: true,
      })
    );
    signInWithEmailAndPassword(auth, data?.email, data?.password)
      .then(async (userCredential) => {
        // Signed in
        dispatch(
          setLoading({
            code: "firebase_admin_login",
            loading: false,
          })
        );
        const user = userCredential.user;
        const token = await user.getIdToken();
        doLogin(token);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;

        if (errorCode == "auth/invalid-credential") {
          toast.error("Invalid credential");
        }

        dispatch(
          setLoading({
            code: "firebase_admin_login",
            loading: false,
          })
        );
      });
  };

  return (
    <div className="w-full flex">
      <div className="w-[50%] h-screen bg-[#00428C]"></div>
      <div className="w-[50%] h-[100vh] flex flex-col justify-center items-center">
        <div className="w-[100%] md:w-[50%] lg:w-[50%] flex gap-[30px] flex-col justify-center items-center px-2 md:px-0 lg:px-0">
          <div className="flex">
            <div className="w-[200px] h-[180px]  rounded-md flex justify-center items-center">
              <img
                src="/Logo_Transaprent.png"
                alt="logo"
                className="w-full h-full"
              />
            </div>
          </div>

          <form
            className="w-full flex flex-col gap-[16px]"
            onSubmit={handleSubmit(handleLogin)}
          >
            <div className="flex w-full h-full flex-col gap-[10px]">
              <div>
                <TextField
                  placeholder="Enter your email"
                  name="email"
                  register={register("email", {
                    required: "Email is required!",
                  })}
                  //   value={formState.email.value}
                  //   onChange={handleChangeForm}
                  errorMessage={errors?.email?.message}
                />
                {/* <p className="text-red-600">{errors?.email?.message}</p> */}
              </div>
              <div>
                <TextField
                  placeholder="Enter your password"
                  name="password"
                  register={register("password", {
                    required: "Password is required!",
                  })}
                  //   value={formState.password.value}
                  //   onChange={handleChangeForm}
                  errorMessage={errors?.password?.message}
                  isPassword={true}
                />
                {/* <p className="text-red-600">{errors?.password?.message}</p> */}
              </div>
              {/* <div className="flex justify-end">
                <Link to={ROTUES.register}>Create Account</Link>
              </div> */}
            </div>

            <Button
              type="submit"
              text="Login"
              className="w-full"
              // isLoading={isLoading}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
